import React, { useState, FC } from "react";
import { notification, Input, Select, Divider, Button } from "antd";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { engGql } from "../../../graphql/engagement";
import { PlusOutlined } from "@ant-design/icons";
import { SelectProps, SelectValue } from "antd/lib/select";

export const ActivityTypeSelect: FC<SelectProps<SelectValue>> = ({ value, onChange }) => {
  const [newValue, setNewValue] = useState("");
  const { data: { engToolActivityTypes } = { engToolActivityTypes: [] }, refetch } = useQuery(
    engGql.engToolActivityTypes
  );

  const [saveEngToolActivityType, { loading: saving }] = useMutation(engGql.saveEngToolActivityType);

  const onAdd = () => {
    if (!newValue.trim()) return;
    saveEngToolActivityType({
      variables: { input: { data: newValue.trim() } },
    })
      .then((res) => {
        notification.success({ message: `Activity type added successfully!` });
        console.log(res.data.saveEngToolActivityType, "saveEngToolActivityType");
        setNewValue("");
        refetch();
      })
      .catch((err) => {});
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      dropdownRender={(menu) => (
        <div>
          {menu}
          <Divider style={{ margin: "4px 0" }} />
          <div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
            <Input
              style={{ flex: "auto" }}
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              addonAfter={
                <Button
                  disabled={!newValue.trim().length}
                  onClick={onAdd}
                  type="link"
                  loading={saving}
                  icon={<PlusOutlined />}
                />
              }
            />
          </div>
        </div>
      )}
    >
      {engToolActivityTypes.map((x: any) => (
        <Select.Option value={x.data} key={x.id}>
          {x.data}
        </Select.Option>
      ))}
    </Select>
  );
};
